export default /* glsl */`
precision mediump float;

varying vec2 vUv;
varying vec3 vColor;

void main() {

    gl_FragColor = vec4(vUv, 0., 1.0);

}
`;
